<template>
<div class="chapter">
<div class="inner_page">
<div class="part">
<div class="title-part"><a href="#/e9781429936446_toc01#toctitle1" id="title1"><span><strong class="b">THE TIN COLLECTORS</strong></span></a></div>
<br/><div class="blocktext"><div class="p-blocktext"><span>Principles serve to govern conduct when there are no rules.</span></div>
<div class="p-d-br-blocktext"><span>—LAPD MANAGEMENT GUIDE<br/> TO DISCIPLINE</span></div></div><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429936446_p01.vue?12f8ca61